import React, { type ReactElement, type ReactNode } from 'react';

import './BackstageRowGrid.scss';

export interface IBackstageRowGridOwnProps {
  children: ReactElement[];
}

export type IBackstageRowGridProps = IBackstageRowGridOwnProps;

export class BackstageRowGrid extends React.Component<IBackstageRowGridProps> {
  render(): ReactNode {
    return <div className='BackstageRowGrid'>{this.props.children}</div>;
  }
}

export default BackstageRowGrid;
